import { TypeaheadItem } from '../typeahead-new.types';

type TypeaheadAriaResultsProps = {
  typeaheadItems: TypeaheadItem[];
  query: string;
  resultsCTA?: {
    label: string;
    link: React.AnchorHTMLAttributes<HTMLAnchorElement> & { href: string };
  };
};

export const TypeaheadAriaResults: React.FC<TypeaheadAriaResultsProps> = ({
  typeaheadItems,
  query,
  resultsCTA,
}) => {
  return (
    <div
      aria-live="polite"
      role="option"
      className="sr-only"
      id={`${name}-typeahead-searchstatus`}
      //TODO: Add dictionary item 'Search.Result.ResultsFound': '{{resultsCount}} results found for {{keyword}}'
    >
      {`${typeaheadItems.length} results found for ${query}`}
      {resultsCTA && (
        <>. {`Last option is ${resultsCTA.label}`}</> //TODO: Add dictionary item 'Search.Result.ResultsCTA': 'Last option is {{ctaLabel}}'
      )}
    </div>
  );
};
